/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GemColor from './GemColor';
import GemEffect from './GemEffect';
import MaterialType from './MaterialType';
import TokenType from './TokenType';

/**
 * The MaterialProperty model module.
 * @module model/MaterialProperty
 * @version 1.0
 */
class MaterialProperty {
    /**
     * Constructs a new <code>MaterialProperty</code>.
     * @alias module:model/MaterialProperty
     */
    constructor() { 
        
        MaterialProperty.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MaterialProperty</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MaterialProperty} obj Optional instance to populate.
     * @return {module:model/MaterialProperty} The populated <code>MaterialProperty</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MaterialProperty();

            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
            if (data.hasOwnProperty('itemType')) {
                obj['itemType'] = MaterialType.constructFromObject(data['itemType']);
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('coinType')) {
                obj['coinType'] = TokenType.constructFromObject(data['coinType']);
            }
            if (data.hasOwnProperty('property1')) {
                obj['property1'] = ApiClient.convertToType(data['property1'], 'Number');
            }
            if (data.hasOwnProperty('property2')) {
                obj['property2'] = ApiClient.convertToType(data['property2'], 'Number');
            }
            if (data.hasOwnProperty('property3')) {
                obj['property3'] = ApiClient.convertToType(data['property3'], 'Number');
            }
            if (data.hasOwnProperty('gemColor')) {
                obj['gemColor'] = GemColor.constructFromObject(data['gemColor']);
            }
            if (data.hasOwnProperty('gemEffect')) {
                obj['gemEffect'] = GemEffect.constructFromObject(data['gemEffect']);
            }
            if (data.hasOwnProperty('gemEffectValue')) {
                obj['gemEffectValue'] = ApiClient.convertToType(data['gemEffectValue'], 'Number');
            }
            if (data.hasOwnProperty('upgradeItemId')) {
                obj['upgradeItemId'] = ApiClient.convertToType(data['upgradeItemId'], 'Number');
            }
            if (data.hasOwnProperty('expireAt')) {
                obj['expireAt'] = ApiClient.convertToType(data['expireAt'], 'Date');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('addCount')) {
                obj['addCount'] = ApiClient.convertToType(data['addCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MaterialProperty</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MaterialProperty</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}



/**
 * @member {Number} itemId
 */
MaterialProperty.prototype['itemId'] = undefined;

/**
 * @member {String} itemName
 */
MaterialProperty.prototype['itemName'] = undefined;

/**
 * @member {module:model/MaterialType} itemType
 */
MaterialProperty.prototype['itemType'] = undefined;

/**
 * @member {Number} level
 */
MaterialProperty.prototype['level'] = undefined;

/**
 * @member {module:model/TokenType} coinType
 */
MaterialProperty.prototype['coinType'] = undefined;

/**
 * @member {Number} property1
 */
MaterialProperty.prototype['property1'] = undefined;

/**
 * @member {Number} property2
 */
MaterialProperty.prototype['property2'] = undefined;

/**
 * @member {Number} property3
 */
MaterialProperty.prototype['property3'] = undefined;

/**
 * @member {module:model/GemColor} gemColor
 */
MaterialProperty.prototype['gemColor'] = undefined;

/**
 * @member {module:model/GemEffect} gemEffect
 */
MaterialProperty.prototype['gemEffect'] = undefined;

/**
 * @member {Number} gemEffectValue
 */
MaterialProperty.prototype['gemEffectValue'] = undefined;

/**
 * @member {Number} upgradeItemId
 */
MaterialProperty.prototype['upgradeItemId'] = undefined;

/**
 * @member {Date} expireAt
 */
MaterialProperty.prototype['expireAt'] = undefined;

/**
 * @member {Number} sort
 */
MaterialProperty.prototype['sort'] = undefined;

/**
 * @member {Number} accountNo
 */
MaterialProperty.prototype['accountNo'] = undefined;

/**
 * @member {Number} itemCount
 */
MaterialProperty.prototype['itemCount'] = undefined;

/**
 * @member {Number} addCount
 */
MaterialProperty.prototype['addCount'] = undefined;






export default MaterialProperty;

